import { faker } from "@faker-js/faker";

export const newsUpdateList = [...Array(5)].map((_, index) => ({
	id: faker.datatype.uuid(),
	title: faker.name.jobTitle(),
	description: faker.name.jobTitle(),
	image: `/assets/images/covers/cover_${index + 1}.jpg`,
	postedAt: faker.date.recent(),
}));

export const orderTimelineList = [...Array(5)].map((_, index) => ({
	id: faker.datatype.uuid(),
	title: [
		"1983, orders, $4220",
		"12 Invoices have been paid",
		"Order #37745 from September",
		"New order placed #XF-2356",
		"New order placed #XF-2346",
	][index],
	type: `order${index + 1}`,
	time: faker.date.past(),
}));
